import { Color, ID } from "src/libs/interfaces/layouts"
import FieldInput, { SCALAR_TYPES } from "src/libs/scalars"
import { __ } from "src/libs/utilities"
import { HISTORY_TYPE, IHistoryStep, ILanding, ILandingFloat, ILandingPrimitive, SELECT_TYPE } from "src/modules/pe-landing-module/data/interfaces"
import { ILandingConsoleStore, ILandingStore, useLandingConsoleStore, useLandingStore } from "src/modules/pe-landing-module/data/store"
import useSelectedContent from "src/modules/pe-landing-module/hooks/useSelectedContent"
import updateSection from "../utils/updateSection"
import { Icon, Tag } from "@blueprintjs/core"

/* Protopia Ecosystem component */
export interface IBorderPanelProps {
   
}
const BorderPanel = (props: IBorderPanelProps): JSX.Element => {
    const border                     = useLandingConsoleStore((state: ILandingConsoleStore) => state.border)
    const currentLanding: ILanding  = useLandingStore((state: ILandingStore) => state.currentLanding)
    const selectedLayer : ID        = useLandingStore((state: ILandingStore) => state.selectedLayer)
    const selectedData              = useSelectedContent()

    const getColor = () => { 
        switch (selectedData.type ) {
            case SELECT_TYPE.CONTENT:
                return ""
            case SELECT_TYPE.FLOAT: 
                const primitives: ILandingPrimitive[]   = selectedData.data?.primitives || [] 
                if(!!primitives[0]) {
                    if(!!primitives[0].stroke) {
                        return primitives[0].stroke || ""
                    }
                }
                else if(!!primitives[1]) {
                    return primitives[1].stroke || ""
                } 
                return "" 
            case SELECT_TYPE.TITLE: 
                return ""
            case SELECT_TYPE.NONE:
            default:
                return border.stroke
        }
    }
    const getWidth = () => {
    switch (selectedData.type ) {
            case SELECT_TYPE.CONTENT:
                return 0
            case SELECT_TYPE.FLOAT: 
                const primitives: ILandingPrimitive[]   = selectedData.data?.primitives || [] 
                if(!!primitives[0]) {
                    if(!!primitives[0].strokeWidth) {
                        return primitives[0].strokeWidth || 0
                    }
                }
                else if(!!primitives[1]) {
                    return primitives[1].strokeWidth || 0
                } 
                return 0 
            case SELECT_TYPE.TITLE: 
                return 0
            case SELECT_TYPE.NONE:
            default:
                return border.strokeWidth
        } 
    }
    const onColor = (color: Color) => {
        let step:IHistoryStep = {
            type: HISTORY_TYPE.SECTION,
            data: null,
            prevData: null,
            title: ""
        }, id: ID

        switch (selectedData.type ) {
            case SELECT_TYPE.CONTENT:
                return color
            case SELECT_TYPE.FLOAT: 
                const primitives: ILandingPrimitive[]   = selectedData.data.primitives || [] 
                id = selectedData.data.id 
                step.prevData = JSON.parse( JSON.stringify( currentLanding.sections.find(section => section.id === selectedLayer) || {} ) )
                step.data = {
                    ...step.prevData,
                    floats: step.prevData.floats?.map((float: ILandingFloat) => {
                        if(float.id === id ) {
                            return {
                                ...float,
                                primitives: primitives.map((primitive: ILandingPrimitive) => {
                                    return {
                                        ...primitive,
                                        stroke: color
                                    }
                                }) 
                            }
                        }
                        return float
                    }) 
                }
                step.title = "Stroke Float"
                updateSection(step.data, step) 
                return color
            case SELECT_TYPE.TITLE: 
                return color
            case SELECT_TYPE.NONE:
            default: 
                useLandingConsoleStore.setState({ border : {
                    ...border,
                    stroke : color,
                } }) 
                return color
        }
    }
    const onWidth = (width: number) => {
        let step:IHistoryStep = {
            type: HISTORY_TYPE.SECTION,
            data: null,
            prevData: null,
            title: ""
        }, id: ID

        switch (selectedData.type ) {
            case SELECT_TYPE.CONTENT:
                return width
            case SELECT_TYPE.FLOAT: 
                const primitives: ILandingPrimitive[]   = selectedData.data.primitives || [] 
                id = selectedData.data.id 
                step.prevData = JSON.parse(JSON.stringify(currentLanding.sections.find(section => section.id === selectedLayer) || {}))
                step.data = {
                    ...step.prevData,
                    floats: step.prevData.floats?.map((float: ILandingFloat) => {
                        if(float.id === id ) {
                            return {
                                ...float,
                                primitives: primitives.map((primitive: ILandingPrimitive) => {
                                    return {
                                        ...primitive,
                                        strokeWidth: width
                                    }
                                }) 
                            }
                        }
                        return float
                    }) 
                }
                step.title = "Stroke Float"
                updateSection(step.data, step) 
                return width
            case SELECT_TYPE.TITLE: 
                return width
            case SELECT_TYPE.NONE:
            default: 
                useLandingConsoleStore.setState({ border : {
                    ...border,
                    strokeWidth : width,
                } }) 
                return width
        }
    }
    const onEyeDrop = () => {
        // https://stackoverflow.com/questions/1936021/javascript-eyedropper-tell-color-of-pixel-under-mouse-cursor
        // https://developer.mozilla.org/en-US/docs/Web/API/EyeDropper_API
        // https://dev.to/atapas/how-to-create-an-eyedropper-tool-using-javascript-3k59

        if('EyeDropper' in window) {
            const eyeDropper = new window.EyeDropper()
            eyeDropper
                .open()
                .then((result: any) => {
                        const color = result.sRGBHex
                        onColor( color )
                    })
                    .catch( (e: any) => {
                        console.error(e)
                    })
        } else {
            console.warn('No Support: This browser does not support the EyeDropper API yet!')
        }
    }

    return <div className="landing-edit-layer"> 
        <div className="panel-list-2 overflow-y-auto pb-3"> 
            <div className="container pr-0 pl-4">
                <FieldInput
                    type={ SCALAR_TYPES.COLOR }
                    editable
                    value={ getColor() }
                    onChange={ onColor }
                    notClear
                />
            </div>

            <div className="px-3 mt-2 small text-uppercase">{ __( "Width" ) }</div>
            <div className="container pr-0 pl-4">
                <FieldInput
                    type={ SCALAR_TYPES.SLIDER }
                    min={ 0 }
                    max={ 20 }
                    stepSize={ 1 }
                    labelStepSize={ 5 }
                    editable
                    value={ getWidth() }
                    disabledLabel
                    onChange={ onWidth }
                    notClear
                />
            </div>
        </div>
        <div className='landing-select-layer-panel'>
            <div className="d-flex pt-1 pl-1 small w-100"> 
                {
                    ('EyeDropper' in window) && <Tag 
                        minimal 
                        size="medium" 
                        className="small text-light py-0 px-1 mb-1 mr-1 hover pointer"
                        onClick={ onEyeDrop } 
                        style={{ height: 22 }}
                    >  
                        <div className="d-flex align-items-center ">
                            <img src={`/assets/img/landing/eye-dropper.svg`} height={10} alt="" className="panel-icon" />
                            <div className="small letter-spacing-1 ml-1">
                                {__("Click chooser color")}
                            </div>
                        </div>
                    </Tag>
                }
            </div>
        </div>
    </div>
}
export default BorderPanel